import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaHeartbeat,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import CallsWrapper from './CallsResults';
import PriorityWrapper from './Priority';



const Calls = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate(`/governanceroom/${props.dashboardPath}`);
    };

    const menus = [
        {
            title: 'Chamados',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/calls-results`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Prioridade',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/priority`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        }
    ];
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/calls-results`]:
            'Chamados',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/priority`]:
            'Prioridade dos Chamados'
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="calls-results" replace />}
                        />
                        <Route
                            path="calls-results"
                            element={<CallsWrapper />}
                        />
                        <Route
                            path="priority"
                            element={<PriorityWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Calls;